import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import { NotificationItem } from '../types'
import NotiItem from './NotiItem'
import { getEnv } from './func'

interface NotiDropdownProps {
  tooltips: NotificationItem[]
  setShowNotiDropdown: Dispatch<SetStateAction<boolean>>
  onNotiClick: (
    client_id: string,
    company_id: string,
    warehouse_id: string,
    client_code_nom: string,
    company_code_nom: string,
    warehouse_code_nom: string
  ) => void
}

const NotiDropdown: FC<NotiDropdownProps> = ({
  tooltips,
  setShowNotiDropdown,
  onNotiClick,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const tooltipsCount = tooltips.length
  const [items, setItems] = useState(tooltips)

  useEffect(() => {
    if (tooltipsCount) {
      setItems(tooltips)
    }
  }, [tooltipsCount])

  const timeout = useRef(null)

  const onChangeInput = (e) => {
    if (timeout.current) {
      clearTimeout(timeout.current)
    }
    timeout.current = setTimeout(() => {
      // @ts-ignore
      const value = e.target.value
      const res = tooltips.filter(
        ({
          client_code,
          client_nom,
          company_code,
          company_nom,
          warehouse_code,
          warehouse_nom,
        }) => {
          const env = getEnv({
            client_code,
            client_nom,
            company_code,
            company_nom,
            warehouse_code,
            warehouse_nom,
          })
          return env.includes(value)
        }
      )
      setItems(res)
    }, 300)
  }

  return tooltipsCount > 0 ? (
    <div
      className="noti-dropdown"
      onMouseLeave={() => setShowNotiDropdown(false)}
      ref={dropdownRef}
    >
      {tooltipsCount > 3 && (
        <div className="env-input-wrapper">
          <input type="text" className="env-input" onInput={onChangeInput} />
        </div>
      )}
      {items.map((item, index) => {
        const {
          client_code,
          client_nom,
          client_id,
          company_id,
          company_code,
          company_nom,
          warehouse_code,
          warehouse_id,
          warehouse_nom,
          quantity,
          isActive,
        } = item
        return (
          <NotiItem
            key={index}
            codeClient={client_code}
            nomClient={client_nom}
            codeCompany={company_code}
            nomCompany={company_nom}
            codeWarehouse={warehouse_code}
            nomWarehouse={warehouse_nom}
            onNotiClick={() =>
              onNotiClick(
                client_id,
                company_id,
                warehouse_id,
                `${client_code}_${client_nom}`,
                `${company_code}_${company_nom}`,
                `${warehouse_code}_${warehouse_nom}`
              )
            }
            quantity={quantity}
            isActive={isActive}
          />
        )
      })}
    </div>
  ) : null
}

export default NotiDropdown
